module.exports = __webpack_public_path__ + "static/media/scoli1-1m.3ad5d4ae.png";